import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Subject, Observable } from 'rxjs';
import { ContactModel } from '../models/contact.model';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  public loginError$ = new Subject<string>();
  public sendEmailSuccess$ = new Subject<string>();
  public sendEmailErr$ = new Subject<string>();
  public emailSendingInProcess$ = new Subject<boolean>();
  public allUsers$: Observable<ContactModel[]>;

  constructor(
    private fun: AngularFireFunctions) { }


  handleError(error: any) {
    this.loginError$.next(error);
    console.error(error);
  }

  sendEmail(data: object) {
    console.log(data);
    // this.emailSendingInProcess$.next(true);
    // setTimeout(() => {
    //   this.emailSendingInProcess$.next(false);
    //   this.handleSuccessEmailSend();
    //   this.handleErrorEmailSend('error');
    // }, 5000);

    this.emailSendingInProcess$.next(true);
    const callable = this.fun.httpsCallable('genericEmail');
    callable(data).subscribe(
      () => this.handleSuccessEmailSend(),
      err => this.handleErrorEmailSend(err));
  }

  handleSuccessEmailSend() {
    console.log('success');
    this.sendEmailSuccess$.next(`ההודעה נשלחה`);
    this.emailSendingInProcess$.next(false);
  }


  handleErrorEmailSend(error: any) {
    this.sendEmailErr$.next('אוווווופס! יש לנו תקלה');
    console.error(error);
    this.emailSendingInProcess$.next(false);
  }

}
